import { createFileRoute } from "@tanstack/react-router";

/**
 * The walkthrough's route options, split from its component
 * (`onboarding.lazy.tsx`) because a lazy route cannot declare `validateSearch`.
 *
 * **A route has to declare the search it accepts, or a client-side navigation
 * drops it.** `?replay=true` reached the root gate perfectly well when it was
 * typed into the address, and vanished when the account menu navigated here:
 * the router filters a `navigate({ search })` against the *destination* route's
 * own schema, so a param this route had never heard of was stripped before
 * anything validated it — and the gate then sent the reader straight back out,
 * having found no reason to keep them. The address bar works because a raw
 * location is parsed once, for the whole route tree.
 *
 * `redirect` is declared for the same reason: the errand a new colleague
 * carries in is read here and by the root gate.
 */
export const Route = createFileRoute("/onboarding")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { redirect?: string; replay?: true } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
    // `true`, not `"1"`: whatever this returns is serialised back into the
    // address, and a string value is JSON-quoted on the way out
    // (`?replay=%221%22`), so it does not come back equal to what was sent.
    replay: search.replay === true ? true : undefined,
  }),
});
